export interface MangaChapter {
  id: number;
  title: string;
  number: number;
  updateDate: string;
}

export interface Manga {
  id: number;
  title: string;
  cover: string;
  author: string;
  status: 'completed' | 'ongoing';
  category: 'korean' | 'chinese' | 'japanese';
  tags: string[];
  rating: number;
  views: number;
  description: string;
  totalChapters: number;
  updateTime: string;
  chapters: MangaChapter[];
}

export const hotMangaList: Manga[] = [
  {
    id: 1,
    title: "都市风云录",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cover%20art%20featuring%20a%20handsome%20businessman%20in%20modern%20city%20setting%2C%20dramatic%20lighting%2C%20clean%20minimalist%20background%20with%20warm%20tones%2C%20digital%20art%20style%2C%20romance%20drama%20genre%2C%20professional%20illustration%20quality&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    author: "林墨",
    status: "completed",
    category: "korean",
    tags: ["都市", "爱情", "职场"],
    rating: 9.5,
    views: 1280000,
    description: "普通上班族意外卷入商业巨头之间的权力斗争，在爱情与事业的双重考验中，他能否守住初心？一部融合都市情感与职场博弈的精彩韩漫，画风精致，剧情跌宕起伏。",
    totalChapters: 120,
    updateTime: "2026-07-28",
    chapters: [],
  },
  {
    id: 2,
    title: "剑道独尊",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20cover%20art%20featuring%20a%20swordsman%20in%20ancient%20Chinese%20martial%20arts%20setting%2C%20flowing%20robes%2C%20dramatic%20pose%20with%20sword%2C%20ink%20wash%20painting%20aesthetic%2C%20clean%20background%2C%20warm%20amber%20tones&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    author: "萧鼎",
    status: "completed",
    category: "chinese",
    tags: ["武侠", "玄幻", "热血"],
    rating: 9.7,
    views: 2560000,
    description: "少年剑客踏上武道巅峰之路，从默默无闻到一剑封神。国漫武侠巨制，宏大的世界观与细腻的人物刻画，带你领略真正的江湖风云。",
    totalChapters: 200,
    updateTime: "2026-08-01",
    chapters: [],
  },
  {
    id: 3,
    title: "甜蜜陷阱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%20featuring%20a%20beautiful%20couple%20in%20cozy%20cafe%20setting%2C%20soft%20pastel%20color%20palette%2C%20warm%20romantic%20atmosphere%2C%20clean%20minimalist%20background%2C%20digital%20illustration%20style%2C%20gentle%20lighting&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    author: "韩雪",
    status: "completed",
    category: "korean",
    tags: ["爱情", "校园", "甜宠"],
    rating: 9.3,
    views: 1890000,
    description: "一场意外的相遇，让两个截然不同的人走进彼此的世界。甜美校园爱情故事，每一页都散发着青春的气息。韩漫甜宠代表作，完结撒花。",
    totalChapters: 85,
    updateTime: "2026-07-15",
    chapters: [],
  },
  {
    id: 4,
    title: "灵异侦探社",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20featuring%20a%20mysterious%20detective%20in%20dark%20urban%20setting%2C%20supernatural%20elements%2C%20moody%20atmosphere%20with%20warm%20amber%20accents%2C%20clean%20composition%2C%20mystery%20thriller%20genre&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    author: "佐藤健一",
    status: "completed",
    category: "japanese",
    tags: ["悬疑", "灵异", "推理"],
    rating: 9.4,
    views: 980000,
    description: "专门处理超自然事件的私家侦探社，每一起案件背后都隐藏着令人毛骨悚然的真相。日漫悬疑力作，烧脑推理与灵异元素完美结合。",
    totalChapters: 64,
    updateTime: "2026-06-20",
    chapters: [],
  },
  {
    id: 5,
    title: "仙界淘宝店",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20featuring%20a%20young%20shopkeeper%20in%20fantasy%20ancient%20Chinese%20marketplace%2C%20magical%20items%2C%20vibrant%20warm%20colors%2C%20clean%20background%2C%20humorous%20fantasy%20genre%2C%20digital%20illustration&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    author: "唐小仙",
    status: "completed",
    category: "chinese",
    tags: ["仙侠", "搞笑", "经营"],
    rating: 9.6,
    views: 3120000,
    description: "普通大学生意外获得仙界淘宝系统，在修仙界开起了独一无二的淘宝店。轻松搞笑的国漫仙侠作品，脑洞大开，笑点密集。",
    totalChapters: 156,
    updateTime: "2026-07-30",
    chapters: [],
  },
  {
    id: 6,
    title: "暗夜王者",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20featuring%20a%20powerful%20male%20character%20in%20dark%20suit%2C%20urban%20night%20setting%2C%20dramatic%20lighting%2C%20mafia%20underworld%20theme%2C%20clean%20composition%2C%20intense%20atmosphere&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    author: "金泰浩",
    status: "completed",
    category: "korean",
    tags: ["动作", "黑帮", "热血"],
    rating: 9.2,
    views: 1650000,
    description: "从最底层爬上来的男人，用拳头和智慧征服地下世界。韩漫硬核动作巨作，拳拳到肉的战斗场面，扣人心弦的权力角逐。",
    totalChapters: 98,
    updateTime: "2026-05-18",
    chapters: [],
  },
  {
    id: 7,
    title: "重生之商业帝国",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20featuring%20a%20successful%20entrepreneur%20in%20modern%20office%20setting%2C%20rebirth%20theme%2C%20warm%20professional%20atmosphere%2C%20clean%20minimalist%20background%2C%20business%20drama%20genre%2C%20digital%20art&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    author: "墨白",
    status: "completed",
    category: "chinese",
    tags: ["重生", "商战", "都市"],
    rating: 9.1,
    views: 1430000,
    description: "商业奇才重生回到二十年前，带着前世记忆打造横跨全球的商业帝国。国漫商战巅峰之作，智斗博弈精彩绝伦。",
    totalChapters: 180,
    updateTime: "2026-07-22",
    chapters: [],
  },
  {
    id: 8,
    title: "樱花下的约定",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20shojo%20manga%20cover%20art%20featuring%20a%20young%20couple%20under%20cherry%20blossom%20tree%2C%20spring%20season%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20pastel%20background%2C%20emotional%20romance%20genre&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    author: "山田花子",
    status: "completed",
    category: "japanese",
    tags: ["爱情", "青春", "治愈"],
    rating: 9.8,
    views: 2780000,
    description: "高中毕业那年樱花树下的约定，十年后能否兑现？日漫纯爱巅峰之作，温暖治愈的青春故事，每一帧都美如画。",
    totalChapters: 42,
    updateTime: "2026-04-10",
    chapters: [],
  },
];

export const allMangaList: Manga[] = [
  ...hotMangaList,
  {
    id: 9,
    title: "末日生存指南",
    cover: "https://readdy.ai/api/search-image?query=Korean%20post-apocalyptic%20manhwa%20cover%20art%20featuring%20survivors%20in%20ruined%20city%2C%20dramatic%20warm%20lighting%2C%20survival%20theme%2C%20clean%20composition%2C%20action%20thriller%20genre%2C%20digital%20illustration&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    author: "崔东勋",
    status: "completed",
    category: "korean",
    tags: ["末世", "生存", "科幻"],
    rating: 9.0,
    views: 890000,
    description: "末日降临，普通人如何在废墟中求生？韩漫末世生存题材代表作，紧张刺激的生存冒险，人性与希望的深刻探讨。",
    totalChapters: 72,
    updateTime: "2026-06-05",
    chapters: [],
  },
  {
    id: 10,
    title: "厨神之路",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20cooking%20manga%20cover%20art%20featuring%20a%20young%20chef%20in%20professional%20kitchen%2C%20delicious%20food%20presentation%2C%20warm%20atmosphere%2C%20clean%20composition%2C%20culinary%20genre%2C%20digital%20illustration&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    author: "田中料理",
    status: "completed",
    category: "japanese",
    tags: ["美食", "竞技", "成长"],
    rating: 9.3,
    views: 1120000,
    description: "怀揣厨师梦想的少年，从路边摊到米其林三星的传奇之路。日漫美食竞技经典，每一道菜品都让人垂涎欲滴。",
    totalChapters: 88,
    updateTime: "2026-07-08",
    chapters: [],
  },
  {
    id: 11,
    title: "妖神记",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20art%20featuring%20a%20demon%20hunter%20in%20ancient%20Chinese%20mythological%20setting%2C%20magical%20creatures%2C%20epic%20atmosphere%2C%20warm%20golden%20tones%2C%20clean%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait",
    author: "风凌天下",
    status: "completed",
    category: "chinese",
    tags: ["玄幻", "修仙", "妖怪"],
    rating: 9.4,
    views: 2010000,
    description: "远古妖神苏醒，人间陷入浩劫。少年踏上降妖除魔之路，揭开万年隐秘。国漫玄幻大作，瑰丽想象与东方美学的完美呈现。",
    totalChapters: 240,
    updateTime: "2026-08-02",
    chapters: [],
  },
  {
    id: 12,
    title: "办公室罗曼史",
    cover: "https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%20art%20featuring%20colleagues%20in%20modern%20office%2C%20romantic%20tension%2C%20warm%20professional%20atmosphere%2C%20clean%20composition%2C%20romance%20comedy%20genre&width=400&height=560&seq=manga-cover-12&orientation=portrait",
    author: "李智恩",
    status: "completed",
    category: "korean",
    tags: ["职场", "爱情", "喜剧"],
    rating: 9.2,
    views: 1340000,
    description: "冷酷上司与元气下属之间的办公室恋情，从互相看不顺眼到暗生情愫。韩漫职场爱情轻喜剧，甜蜜又真实的日常。",
    totalChapters: 55,
    updateTime: "2026-05-30",
    chapters: [],
  },
];

export const categories = [
  { name: "全部", slug: "all", icon: "ri-grid-line", color: "bg-primary-500" },
  { name: "韩漫全集", slug: "korean", icon: "ri-global-line", color: "bg-accent-500" },
  { name: "国漫全集", slug: "chinese", icon: "ri-earth-line", color: "bg-secondary-500" },
  { name: "日漫完结", slug: "japanese", icon: "ri-sun-line", color: "bg-primary-400" },
  { name: "完结佳作", slug: "completed", icon: "ri-check-double-line", color: "bg-accent-400" },
];

export const sortOptions = [
  { name: "最受欢迎", value: "popular" },
  { name: "最近更新", value: "latest" },
  { name: "章节最多", value: "chapters" },
];

export interface Testimonial {
  name: string;
  avatar: string;
  rating: number;
  comment: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "漫画爱好者小明",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20young%20Chinese%20boy%2C%20warm%20smile%2C%20simple%20clean%20style%2C%20flat%20illustration%2C%20soft%20colors&width=80&height=80&seq=avatar-01&orientation=squarish",
    rating: 5,
    comment: "终于找到一个全是完结漫画的平台了！再也不用忍受追更的痛苦，一次看个爽。咻咻漫画的下拉式阅读体验太棒了，流畅丝滑！",
    date: "2026-07-20",
  },
  {
    name: "韩漫迷妹小丽",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20young%20Chinese%20girl%2C%20gentle%20smile%2C%20simple%20clean%20style%2C%20flat%20illustration%2C%20soft%20pastel%20colors&width=80&height=80&seq=avatar-02&orientation=squarish",
    rating: 5,
    comment: "韩漫资源太全了！把我一直在找的几部完结韩漫全收录了，画质清晰，加载速度也快，每天都要来这里刷好几个小时。",
    date: "2026-07-25",
  },
  {
    name: "国漫死忠粉大强",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20young%20man%2C%20confident%20expression%2C%20simple%20clean%20style%2C%20flat%20illustration%2C%20warm%20colors&width=80&height=80&seq=avatar-03&orientation=squarish",
    rating: 5,
    comment: "作为国漫老粉，咻咻漫画的国漫全集分类太良心了！很多经典作品在这里都能找到，推荐给了身边所有朋友。",
    date: "2026-07-28",
  },
  {
    name: "日漫收藏家老王",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20middle%20aged%20man%2C%20friendly%20smile%2C%20simple%20clean%20style%2C%20flat%20illustration%2C%20warm%20neutral%20colors&width=80&height=80&seq=avatar-04&orientation=squarish",
    rating: 5,
    comment: "日漫完结佳作区简直是宝藏！很多绝版的老漫画在这里都能找到，重温青春回忆的感觉太美好了。",
    date: "2026-08-01",
  },
];

export const faqList = [
  {
    question: "咻咻漫画上的所有漫画都是免费的吗？",
    answer: "是的，咻咻漫画平台上的所有漫画资源完全免费，无需任何付费订阅即可畅读全部内容。我们致力于为广大漫画爱好者提供零门槛的阅读体验。",
  },
  {
    question: "网站上的漫画都是全集完结的吗？",
    answer: "咻咻漫画专注于收录已完结的漫画作品，包括韩漫全集、国漫全集和日漫完结佳作。我们希望读者能够一次性完整地阅读喜欢的作品，而不是在追更中等待。",
  },
  {
    question: "什么是下拉式阅读模式？",
    answer: "下拉式阅读是咻咻漫画的特色阅读方式。与传统的翻页阅读不同，下拉式阅读让您可以像浏览网页一样，通过向下滚动来连续阅读漫画内容，体验更加流畅自然。",
  },
  {
    question: "支持在手机上阅读吗？",
    answer: "当然支持！咻咻漫画网站采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备，都能获得舒适的下拉式阅读体验。",
  },
  {
    question: "漫画资源会定期更新吗？",
    answer: "会的！我们的编辑团队会持续收录最新完结的优质漫画作品，不断丰富平台资源库。建议您定期访问或关注我们的社交媒体账号获取最新上架信息。",
  },
];